import {ChangeDetectorRef, Directive, OnDestroy} from "@angular/core";
import {CdkPortalOutlet} from "@angular/cdk/portal";
import {Subscription} from "rxjs";
import {MatExpansionPanel} from "@angular/material/expansion";
import {skip} from "rxjs/operators";

// https://github.com/angular/components/issues/14626
// https://stackblitz.com/edit/angular-os5cc6?file=src%2Fapp%2Fexpansion-overview-example.html

@Directive({
  selector: "[portalHandler]"
})
export class PortalHandlerDirective implements OnDestroy {
  hostCD: ChangeDetectorRef;
  portalOutlet: CdkPortalOutlet;
  subscription = new Subscription();
  constructor( private host: MatExpansionPanel ) {
    this.subscription.add(
      this.host.opened.pipe(skip(1)).subscribe(() => this.handlePortal(true))
    );
    this.subscription.add(
      this.host.afterCollapse.subscribe(() => this.handlePortal(false))
    );
  }

  handlePortal(expanded: boolean) {
    if (!this.host['_portal']) return;
    const hCD = this.host['_changeDetectorRef'] as ChangeDetectorRef;
    if (expanded) {
      // hCD.reattach();
      this.host['_portal'].attach(this.portalOutlet);
    } else {
      // hCD.detach();
      if (!this.portalOutlet) { this.portalOutlet = this.host['_portal']['_attachedHost']; }
      this.host['_portal'].detach();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}


